// src/BeneficiariesPage.js
//
// UPDATED to full CRUD. Uses date_of_birth (the real model field name)
// and activities_label (comma-free list) for display.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import BeneficiaryForm from './BeneficiaryForm';

function BeneficiariesPage({ token }) {
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingBeneficiary, setEditingBeneficiary] = useState(null);

  const refreshBeneficiaries = () => {
    fetch(`${API_BASE_URL}/api/beneficiaries/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setBeneficiaries(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshBeneficiaries();
  }, [token]);

  const handleNewClick = () => { setEditingBeneficiary(null); setShowForm(true); };
  const handleEditClick = (b) => { setEditingBeneficiary(b); setShowForm(true); };
  const handleSaved = () => { setShowForm(false); setEditingBeneficiary(null); refreshBeneficiaries(); };
  const handleCancel = () => { setShowForm(false); setEditingBeneficiary(null); };

  const handleDelete = async (b) => {
    const confirmed = window.confirm(`Delete beneficiary "${b.full_name}"? This cannot be undone.`);
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/beneficiaries/${b.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshBeneficiaries();
  };

  if (loading) return <p className="text-gray-500">Loading beneficiaries...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Beneficiaries</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Beneficiary
        </button>
      </div>

      {showForm && (
        <BeneficiaryForm token={token} beneficiary={editingBeneficiary} onSaved={handleSaved} onCancel={handleCancel} />
      )}

      <table className="w-full bg-white rounded shadow">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Full Name</th>
            <th className="p-3">Gender</th>
            <th className="p-3">Location</th>
            <th className="p-3">Contact Number</th>
            <th className="p-3">Activities</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {beneficiaries.map((b) => (
            <tr key={b.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{b.full_name}</td>
              <td className="p-3">{b.gender || 'N/A'}</td>
              <td className="p-3">{b.location || 'N/A'}</td>
              <td className="p-3">{b.contact_number || 'N/A'}</td>
              {/* .join(', ') turns the array of activity names into a
                  single readable comma-separated string */}
              <td className="p-3">{(b.activities_label || []).join(', ') || 'N/A'}</td>
              <td className="p-3">
                <button onClick={() => handleEditClick(b)} className="text-blue-600 text-sm hover:underline mr-3">Edit</button>
                <button onClick={() => handleDelete(b)} className="text-red-600 text-sm hover:underline">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BeneficiariesPage;
